import {useTemplate} from 'Event/TemplateProvider'
import React from 'react'
import styled from 'styled-components'

export default function DescriptionText(props: {
  children: string
  'aria-label'?: string
  className?: string
}) {
  const {login, textColor} = useTemplate()
  const color =
    login.passwordReset.descriptionTextColor ||
    login.description.color ||
    textColor
  const fontSize =
    login.passwordReset.descriptionFontSize ?? login.description.fontSize

  if (!props.children) {
    return null
  }

  return (
    <StyledText
      textColor={color}
      fontSize={fontSize}
      aria-label={props['aria-label']}
      className={props.className}
    >
      {props.children}
    </StyledText>
  )
}

export const StyledText = styled.div<{
  textColor?: string | null
  fontSize: number
}>`
  color: ${(props) => props.textColor};
  font-size: ${(props) => props.fontSize}px;
  font-weight: 500;
  margin-bottom: ${(props) => props.theme.spacing[8]};
  text-align: center;
`
